import { z } from 'zod';
import {
  requiredIntFromNumberInput,
  requiredReferenceIdSchema,
  telefoneFormSchema,
} from '@/shared/utils/formZod.schema.utils';

export const predioFormSchema = z
  .object({
    ordem: requiredIntFromNumberInput({
      requiredMessage: 'Informe a ordem',
      min: 0,
      minMessage: 'A ordem deve ser zero ou maior',
    }),
    nome: z.string().trim().min(1, 'Informe o nome da unidade'),
    apelido: z
      .string()
      .trim()
      .optional()
      .transform((v) => (v === '' ? undefined : v)),
    comarca: requiredReferenceIdSchema,
    endereco: z
      .object({
        cep: z.string().trim().optional(),
        cidade: z.string().trim().optional(),
        bairro: z.string().trim().optional(),
        logradouro: z.string().trim().optional(),
        complemento: z.string().trim().optional(),
        numero: z.union([z.string(), z.number()]).optional(),
      })
      .optional(),
    telefoneprincipal: telefoneFormSchema,
    telefonesecundario: telefoneFormSchema,
  })
  .passthrough();

export type PredioFormValues = z.infer<typeof predioFormSchema>;
